// @mui material components
import {
  Snackbar,
  Alert,
  // Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  FormGroup,
  FormControl,
  FormControlLabel,
  // FormLabel,
  Checkbox,
  RadioGroup,
  Radio,
  Dialog,
  DialogContent,
  // DialogContentText,
  // DialogTitle,
  DialogActions,
  Button,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import usePageTitle from "app/pageTitle";

function CourseTest() {
  const pageTitle = "Course Assessment";
  usePageTitle(pageTitle);

  const { id: reference } = useParams();
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [course, setCourse] = useState(null);
  const [quiz, setQuiz] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});

  const [quizResult, setQuizResult] = useState({});
  const [openQuizResultDialog, setOpenQuizResultDialog] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`agents/trainings/courses/tests/${reference}/fetch.json`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setCourse(result.data.data.course);
            setQuiz(result.data.data.test);
            setQuestions(result.data.data.questions);

            const preAnswers = {};
            result.data.data.questions.forEach((question) => {
              if (question.answer_type === "MULTIPLE") {
                preAnswers[question.reference] = [];
              } else {
                preAnswers[question.reference] = null;
              }
            });
            setAnswers(preAnswers);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  async function submitTest() {
    // let answered = 0;
    // answers.forEach((answer) => {
    //   if (answer) {
    //     answered += 1;
    //   }
    // });

    // if (answered < answers.length) {
    //   console.log("LESS");
    // }

    setShowLoading(true);

    const json = {
      reference: `${reference}`,
      submission: answers,
    };

    console.log(json);

    await axios
      .post("agents/trainings/courses/tests/submit.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setQuizResult(result.data.data);
          setOpenQuizResultDialog(true);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>

      <Dialog open={openQuizResultDialog} fullWidth maxWidth="xs">
        <DialogContent>
          <MDBox align="center">
            <MDBox mt={2}>
              <MDTypography variant="h6" fontWeight="light">
                You Scored
              </MDTypography>
              <MDTypography variant="h2" fontWeight="medium">
                {(quizResult.score * 100).toLocaleString("en", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
                %
              </MDTypography>
            </MDBox>
            <MDBox mt={2}>
              <Icon
                fontSize="large"
                sx={{ fontSize: 120 }}
                color={quizResult.passed ? "success" : "error"}
                variant="outlined"
              >
                {quizResult.passed ? "check_circle_outline" : "cancel"}
              </Icon>
            </MDBox>
            <MDBox mt={2}>
              {quizResult.passed ? (
                <MDTypography variant="h6" fontWeight="light">
                  <b>Congratulations!</b>
                  <br />
                  You passed!
                </MDTypography>
              ) : (
                <MDTypography variant="h6" fontWeight="light">
                  <b>Too bad</b>
                  <br />
                  You did not make the pass score.
                  <br />
                  You can try again.
                </MDTypography>
              )}
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenQuizResultDialog(false);
              navigate("/courses");
            }}
            color="dark"
            variant="outlined"
            iconOnly
            circular
          >
            <Icon>close</Icon>
          </MDButton>
        </DialogActions>
      </Dialog>

      {quiz !== null && (
        <MDBox pt={3} pb={3}>
          <MDBox>
            <Button
              size="small"
              color="dark"
              startIcon={<Icon>west</Icon>}
              onClick={() => {
                navigate(`/courses/${course}`);
              }}
            >
              Back To Course
            </Button>
          </MDBox>
          <MDBox mt={2}>
            <Card sx={{ height: "100%", marginTop: "0px" }}>
              <MDBox p={3}>
                <MDBox>
                  <MDTypography variant="h6" fontWeight="medium">
                    {quiz.title}
                  </MDTypography>
                  <MDTypography variant="h6" fontWeight="light" mt={1}>
                    {quiz.description}
                  </MDTypography>
                  <MDTypography variant="h6" fontWeight="medium" mt={2}>
                    Pass Mark: {quiz.pass_mark * 100}%
                  </MDTypography>
                </MDBox>
              </MDBox>
            </Card>
          </MDBox>
          <MDBox mt={5}>
            {questions.map((question, index) => (
              <MDBox mb={3}>
                <Card sx={{ height: "100%", marginTop: "0px" }}>
                  <MDBox p={3}>
                    <MDTypography variant="h6" fontWeight="regular">
                      <b>{index + 1}.</b> {question.question}
                    </MDTypography>
                    {question.answer_type === "SINGLE" ? (
                      <MDBox>
                        <FormControl>
                          {/* <FormLabel id="demo-controlled-radio-buttons-group">
                                  {question.question}
                                </FormLabel> */}
                          <RadioGroup
                            onChange={(e) => {
                              answers[question.reference] = e.target.value;
                              setAnswers(answers);
                              console.log(answers);
                            }}
                          >
                            {question.answers.map((answer) => (
                              <FormControlLabel
                                value={answer.key}
                                control={<Radio />}
                                label={
                                  <MDTypography variant="text" fontWeight="light">
                                    {answer.value}
                                  </MDTypography>
                                }
                              />
                            ))}
                          </RadioGroup>
                        </FormControl>
                      </MDBox>
                    ) : (
                      <MDBox>
                        <FormGroup
                          onChange={(e) => {
                            if (e.target.checked) {
                              if (!answers[question.reference].includes(e.target.value)) {
                                answers[question.reference].push(e.target.value);
                                setAnswers(answers);
                              }
                            } else {
                              if (!answers[question.reference].includes(e.target.value)) {
                                return;
                              }

                              const indx = answers[question.reference].indexOf(e.target.value);
                              answers[question.reference].splice(indx, 1);
                              setAnswers(answers);
                            }

                            console.log(answers);
                          }}
                        >
                          {question.answers.map((answer) => (
                            <FormControlLabel
                              value={answer.key}
                              control={<Checkbox />}
                              label={
                                <MDTypography variant="text" fontWeight="light">
                                  {answer.value}
                                </MDTypography>
                              }
                            />
                          ))}
                        </FormGroup>
                      </MDBox>
                    )}
                  </MDBox>
                </Card>
              </MDBox>
            ))}
          </MDBox>
          <MDBox mt={5}>
            <Card sx={{ width: "100%", marginTop: "0px" }}>
              <MDBox mt={1} p={3} align="center">
                <MDButton
                  color="dark"
                  variant="contained"
                  onClick={() => {
                    console.log(answers);
                    if (window.confirm(`Are you ready to submit quiz?`) === true) {
                      submitTest();
                    }
                  }}
                >
                  Submit
                </MDButton>
              </MDBox>
            </Card>
          </MDBox>
        </MDBox>
      )}
      <Footer />
    </DashboardLayout>
  );
}

export default CourseTest;
